import type { SerializedKitAsset } from '../../../redux/api/fymAPI.types';
import { drawnFileSrc } from '../../common/drawnImageSrc';

/** The picture fields of a kit asset: the file routes and their imgproxy sources. */
export type KitAssetPictureSources = Pick<
  SerializedKitAsset,
  'fileUrl' | 'posterUrl' | 'thumbUrl' | 'fileSourceUrl' | 'posterSourceUrl' | 'thumbSourceUrl'
>;

/** One picture of a file: the relative file route and its imgproxy source. */
export interface KitPicture {
  url: string;
  sourceUrl: string | null;
}

/**
 * The `<img>` source of a kit picture at `cssPx` CSS pixels (owner rule 2026-10-19; QA
 * 2026-10-28, mob-7: the Kit and Posts thumbnails loaded the full-size files). Through imgproxy
 * when the API gave the source, else the file route.
 */
export function kitPictureSrc(picture: KitPicture, cssPx: number): string {
  return drawnFileSrc({ url: picture.url, sourceUrl: picture.sourceUrl ?? undefined }, cssPx);
}

/** The poster of a video asset, else its image file. Null with neither. */
export function kitAssetPicture(asset: KitAssetPictureSources, isVideo: boolean): KitPicture | null {
  if (asset.posterUrl !== null) {
    return { url: asset.posterUrl, sourceUrl: asset.posterSourceUrl ?? null };
  }
  if (!isVideo && asset.fileUrl !== null) {
    return { url: asset.fileUrl, sourceUrl: asset.fileSourceUrl ?? null };
  }
  return null;
}

/** The small JPEG of the asset first (the Posts rows), else `kitAssetPicture`. */
export function kitAssetThumbPicture(asset: KitAssetPictureSources, isVideo: boolean): KitPicture | null {
  if (asset.thumbUrl !== null && asset.thumbUrl !== undefined) {
    return { url: asset.thumbUrl, sourceUrl: asset.thumbSourceUrl ?? null };
  }
  return kitAssetPicture(asset, isVideo);
}
